var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotorsports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_6847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.78498 13.6928C7.2705 13.5631 6.07744 12.2897 6.07744 10.7423C6.07744 9.10885 7.4063 7.77999 9.0397 7.77999C10.0461 7.77999 10.9364 8.28493 11.472 9.05429H22.5312C21.8504 6.92495 20.586 5.01169 18.868 3.54774C16.6894 1.69135 13.9132 0.668961 11.0509 0.668961C8.09911 0.668961 5.32402 1.81848 3.23677 3.90573C2.58211 4.56038 2.01984 5.28273 1.5562 6.05691H2.93452V7.46326H0.846516C0.630656 7.98066 0.454875 8.51471 0.320437 9.06155H2.93452V10.4679H0.0705C0.0242344 10.8806 0 11.2983 0 11.7199C0 15.0969 0.972375 18.3786 2.81198 21.2105L2.82398 21.229L22.2657 23.3311C22.8886 22.6207 23.3677 21.7805 23.6595 20.8826C23.971 19.9239 24.0707 18.8931 23.9507 17.8919H9.81713L8.78498 13.6928Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03932 12.2982C9.89863 12.2982 10.5952 11.6016 10.5952 10.7423C10.5952 9.88295 9.89863 9.18634 9.03932 9.18634C8.18001 9.18634 7.4834 9.88295 7.4834 10.7423C7.4834 11.6016 8.18001 12.2982 9.03932 12.2982Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8162 16.4855L11.675 12.0922C11.3563 12.7118 10.826 13.2054 10.1797 13.476L10.9194 16.4855H12.8162Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9496 10.8026C22.9311 10.6881 22.9105 10.5743 22.8888 10.4606H12.7041L14.2691 16.4855H23.7537L22.9496 10.8026Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_6847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorsports);
export default __webpack_public_path__ + "static/media/motorsports.9aeee226b93ae0054f249131cf166413.svg";
export { ForwardRef as ReactComponent };